<template lang="pug">
.fake-wrap
  .products__goods
    catalogitem(
      v-for="item in items"
      :key="item.id"
      :item="item"
    )
  pagination(
    v-if="pageCount > 0"
    v-bind:pageCount="pageCount"
    v-bind:activePage="activePage"
  )
</template>



<script>
  import store from '~/js/store'
  import catalogitem from '~/pug/blocks/catalog-item/catalog-item.vue'
  import pagination from '~/pug/blocks/pagination/pagination.vue'

  const productItems = {
    data() {
      return {
      }
    },
    components: {
      catalogitem, pagination
    },
    computed: {
      items () {
        let items
        let page

        page = this.page()
        items = []

        if (typeof store.state.productItems[page] === 'object') {
          items = store.state.productItems[page].map(function(item) {
            return {
              id: item.ID,
              title: item.NAME,
              url: item.DETAIL_PAGE_URL,
              image: item.image,
              description: item.PREVIEW_TEXT,
              price: item.CATALOG_PRICE_1
            }
          })
        }
        return items
      },
      pageCount () {
        let length
        length = store.state.productItems.length

        return length
      },
      activePage() {
        return parseInt(store.state.productItemsPage)
      }
    },
    methods: {
      page () {
        return store.state.productItemsPage - 1
      },
    }
  }

  export default productItems
</script>
